import UpsellSetting from "../componens/upsellSetting";
import "./Upsell.css";

export default function Upsell() {
  return <UpsellSetting />;
}
